import React from "react";
import { motion } from "framer-motion";
import { Info } from "lucide-react";
import ChartRenderer from "./ChartRenderer";

export default function ChartCard({ spec }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      className="bg-white border border-gray-200 rounded-xl p-6 shadow-[0_1px_3px_rgba(0,0,0,0.04)]"
    >
      <div className="mb-5">
        <h3 className="text-lg font-semibold text-gray-900 tracking-tight">{spec.title}</h3>
        {spec.subtitle && <p className="text-sm text-gray-500 mt-1">{spec.subtitle}</p>}
      </div>
      <ChartRenderer spec={spec} />
      {spec.caveat && (
        <div className="mt-5 flex items-start gap-2 px-3 py-2.5 bg-amber-50 border-l-2 border-amber-400 rounded-r">
          <Info className="w-3.5 h-3.5 text-amber-600 flex-shrink-0 mt-0.5" strokeWidth={2} />
          <p className="text-xs text-amber-900 italic leading-relaxed">{spec.caveat}</p>
        </div>
      )}
    </motion.div>
  );
}
